import React, { Component } from "react";
import { LegendComp, PieGraph } from "../../../../../common/graph/pie-chart.component";

class AuditGraph extends Component {

    calculateTotal(data) {
        return data.reduce((acc, item) => acc + item.value, 0);
    }

    render(){
        const total = this.calculateTotal(this.props.pieChart);
        const isDataEmpty = this.props.pieChart.length === 0;
        return(          
            <div>
                 <h1 className="audit-title">{this.props.graphTitle}</h1>
                 <div className={`audit-graph ${isDataEmpty && "d-flex"}`}>
                   {
                    isDataEmpty ?
                         <div className="no-data-message">No data retrieved</div>
                    :
                    <>
                        <h1>{this.props.pieChartTitle}</h1>
                        <div className="audit-graph__inner-container">
                            <LegendComp data={this.props.ledgerData} />
                            <span className="audit-graph__total">{total}</span>
                            <PieGraph customHeight={this.props.customCY} data={this.props.pieChart} displayLegend={true} legendData={this.props.pieData}/> 
                        </div>   
                    </>
                   }                         
                </div>
            </div>
        )
    }
}

export default AuditGraph;